import React from "react";

const Footer = () => {
  return <div className="absolute-center">© Copyright 2024</div>;
};

export default Footer;
